// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"9e871684","150":"4293ecf1","382":"656a3eac","453":"51a16142","637":"9089a617","659":"fbb56eb9","750":"6041e952","938":"276164d3"}[chunkId] + ".chunk.js";
};